import { createI18n, I18nOptions } from 'vue-i18n'
import enUS from './common/locales/en-US.json' with { type: 'json' }

const options: I18nOptions = {
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
  locale: navigator.language,
  fallbackLocale: 'en-US',
  messages: {
    'en-US': enUS,
  },
  numberFormats: {
    'en-US': {
      currency: {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'USD',
      },

      decimal: {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      },
    },
  },
}

export function createAppI18n() {
  return createI18n<false, typeof options>(options) 
}

export function createTranslator() {
  return createAppI18n().global.t
}